import axios from 'axios'
import store from './../store'

const baseURL = '/dup'
// 请求拦截，在发送请求之前
axios.interceptors.request.use(function (config) {
  return config
}, function (error) {
  return Promise.reject(error)
})

// 请求回来时，修改返回的数据
axios.interceptors.response.use(function (res) {
  return res.data
}, function (error) {
  return Promise.reject(error)
})

function errorState (response) {
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    return response
  } else if (response && ((response.status === 403) || (response.code === 401))) {
    // 请求无权限，显示无权限页面，或直接跳转到登陆页
    store.commit('sessionMiss', response.msg)
  } else {
    // 其他情况，将错误信息曝出
    store.commit('showErrorMsg', {errMsg: response.msg || response.status})
  }
}

function successState (response) {
  // TODO 需要约定请求的code类型
  if (response.code === 200) {
    // 提示请求成功
    return response
  } else {
    // 其他情况，将错误信息曝出
    errorState(response)
    return null;
  }
}

// 封装axios
const httpServer = (opts, data) => {
  let httpDefaultOpts = {
    method: opts.method,
    baseURL: baseURL,
    url: opts.url,
    timeout: 1800000, // 前端30min延时控制
    params: data,
    data: data,
    headers: opts.type === 'formdata' ? {
      'Content-Type': 'multipart/form-data',
      'token': store.state.user.token
    } : {
      'token': store.state.user.token
    }
  }
  if (opts.method === 'get' || opts.method === 'GET') {
    delete httpDefaultOpts.data
  } else {
    delete httpDefaultOpts.params
  }
  return new Promise(function (resolve, reject) {
    axios(httpDefaultOpts).then(
      (res) => {
        // 只有验证成功后再执行resolve程序
        if (successState(res)) {
          resolve(res)
        } else {
          reject(res)
        }
      }
    ).catch(
      (err) => {
        errorState(err)
        reject(err)
      }
    )
  })
}

export default {
  install: function (Vue) {
    Vue.prototype.fetch = (url, params) => httpServer({method: 'GET', url: url}, params)
    Vue.prototype.post = (url, params) => httpServer({method: 'POST', url: url}, params)
  }
}



// WEBPACK FOOTER //
// ./src/utils/request.js